import { render, staticRenderFns } from "./ProductCategoryDialog.vue?vue&type=template&id=2b313ac0&scoped=true&"
import script from "./ProductCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryDialog.vue?vue&type=style&index=0&id=2b313ac0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b313ac0",
  null
  
)

export default component.exports